import React, { useEffect, useState } from "react";
import axios from "axios";
import DocumentMeta from "react-document-meta";
import * as myConstList from "../../Common/BaseUrl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { Link } from "react-router-dom";
import { CountryDropdown } from "react-country-region-selector";
import { EmailValidation } from "../../Validation/EmailValidation";
import { MobileValidation } from "../../Validation/MobileValidation";
import { PasswordValidation } from "../../Validation/PasswordValidation";
import { meta } from "../../Common/Meatdata";
import { ProductName } from "../../Common/ProductName";
import {
  useRegisterUserMutation,
  useSignUpSendOtpMutation,
  useSignUpVerifyOtpMutation,
} from "../../../redux/auth";
import { isValidPhoneNumber } from "libphonenumber-js";
import { useLocation } from "react-router-dom";

const baseUrl = myConstList.baseUrl;

const RegisterFunction = (props) => {
  const { search } = useLocation(); // gives you "?ref=name"
  const queryParams = new URLSearchParams(search);
  const ref = queryParams.get("ref");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState(false);
  const [CPassword, setCPassword] = useState("");
  const [Password, setPassword] = useState("");
  const [type, setType] = useState("password");
  const [type1, setType1] = useState("password");
  const [textForCode, setTextForCode] = useState("Get Code");
  const [counter, setCounter] = useState(0);
  const [ReferId, setReferId] = useState(ref || "");
  const [timerText, setTimerText] = useState("");
  const [check1, setCheck1] = useState("0");
  const [countryCode, setCountryCode] = useState("+91");
  const [PasswordIssue, setPasswordIssue] = useState("");
  const [CPasswordIssue, setCPasswordIssue] = useState("");
  const [codeMatchedStatus, setCodeMatchedStatus] = useState(false);
  const [buttonDisableVerification, setButtonDisableVerification] =
    useState(true);
  const [messageCheck1, setMessageCheck1] = useState("");
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [verificationError, setVerificationError] = useState("");
  const [referalError, setReferalError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [VerificationCode, setVerificationCode] = useState("");
  const [signUpSendOtp, { isLoading: gettingCode }] =
    useSignUpSendOtpMutation();
  const [signUpVerifyOtp, { isLoading: verifyingCode }] =
    useSignUpVerifyOtpMutation();
  const [registerUser, { isLoading: registeringUser }] =
    useRegisterUserMutation();
  const [disableButton, setDisableButton] = useState(false);
  const [registerVia, setRegisterVia] = useState("email");

  useEffect(() => {
    if (localStorage.getItem("token")) {
      window.location.href = "/";
      return false;
    }

    meta.title = `Signup | ${ProductName} Exchange`;
    meta.description = `Signup in ${ProductName} Exchange to enjoy its features`;

    if (props && props.referId !== undefined) {
      setReferId(props.referId);
    }

    if (localStorage.checkbox && localStorage.email !== "") {
      setEmail(localStorage.email);
      setPassword(localStorage.password);
    }
  }, []);

  const referCode = () => {
    let registerData = {
      email: email,
    };
    axios
      .post(baseUrl + "/frontapi/generateReferalCode", registerData)
      .then((res) => {
        var resp = res.data;
        if (resp.status === true) {
          toast.dismiss();
          toast.success(resp.message);
        }
      });
  };

  const startCountdown = (seconds) => {
    let counter = seconds;
    const interval = setInterval(() => {
      setCounter(counter);
      setTimerText("Resend In");
      setBtnDisabled(true);
      counter--;
      if (counter < 0) {
        clearInterval(interval);

        setTextForCode("Resend Code");
        setBtnDisabled(false);
        setTimerText("");
      }
    }, 1000);
  };

  const handleCountryCode = (countryCode) => {
    setCountryCode("+" + countryCode);
    setEmailError("");
    setMobileError("");
    setVerificationError("");
    setMobile("");
    setEmail("");
  };

  const getCode = async (event) => {
    event.preventDefault();

    const emailReg =
      /^[a-zA-Z\d\.-]+@([a-zA-Z\.-]+)\.([a-zA-Z]{2,8})([a-zA-Z]{2,8})?$/;

    // if (countryCode !== "+91") {
    //   if (!email) return setEmailError("Email address is required");

    //   if (emailError) return;
    // }
    if (registerVia === "phone") {
      if (!mobile) {
        setMobileError("This field is required");
        return;
      }

      const fullNumber = countryCode + mobile;

      // must contain only digits, no dots, spaces, or symbols
      if (!/^\d+$/.test(mobile)) {
        return setMobileError("Mobile number must contain digits only");
      }

      // reject same-digit numbers like 9999999999, 8888888888
      if (/^(\d)\1+$/.test(mobile)) {
        return setMobileError("Invalid mobile number");
      }

      if (!isValidPhoneNumber(fullNumber)) {
        return setMobileError("Please enter a valid mobile number");
      }

      setMobileError("");
    }

    if (registerVia === "email") {
      if (!email) {
        setEmailError("This field is required");
        return;
      }

      if (!email.match(emailReg))
        return setEmailError("Please enter a valid email address");

      setEmailError("");
    }

    // if (!mobile) {
    //   return setMobileError("This field is required");
    // }

    setMobileError(""); // clear error if valid
    setBtnDisabled(true);
    setVerificationCode("");
    setVerificationError("");

    let registerData = {
      country_code: countryCode,
      type: registerVia,
      page: "register",
      // ...(countryCode === "+91" ? { phone: mobile } : { email }),
      phone: mobile || "",
      email: email == true ? "" : email,
    };

    try {
      const { data, error } = await signUpSendOtp(registerData);
      if (error) {
        toast.error(error?.data?.message || "Something went wrong");
        setTimeout(() => {
          setBtnDisabled(false);
        }, 2000);
        return;
      }

      if (data?.status) {
        toast.dismiss();
        toast.success(data.message || "OTP sent");
        setVerificationError("");
        startCountdown(30);
        setButtonDisableVerification(false);
      } else {
        toast.dismiss();
        toast.error(data?.message || "OTP failed");
        setButtonDisableVerification(true);
      }
    } catch (err) {
      console.error("Unexpected error:", err);
      toast.error("Unexpected error occurred");
    }
  };

  const handleChange1 = (event) => {
    var messageCheck1 = "";
    if (event.target.checked == false) {
      messageCheck1 = "This field is required";
      console.log("checked", event.target.checked);
      setCheck1("0");
      setMessageCheck1(messageCheck1);
    }
    if (event.target.checked == true) {
      setCheck1("1");
      setMessageCheck1(messageCheck1);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // 🚨 Block submission if password errors exist
    if (PasswordIssue || CPasswordIssue) {
      return;
    }

    // 🚨 Block if password is empty
    if (!Password || !CPassword) {
      setPasswordIssue(!Password ? "This field is required" : "");
      setCPasswordIssue(!CPassword ? "This field is required" : "");
      return;
    }

    // 🚨 Block if password & confirm password don’t match
    if (Password !== CPassword) {
      setCPasswordIssue("Passwords do not match");
      return;
    }

    // 🚨 Block if checkbox is not checked
    if (check1 === "0") {
      setMessageCheck1("This field is required");
      return;
    }

    // ✅ Passed validation → submit
    let registerData = {
      password: CPassword,
      referal_from: ReferId,
    };

    setDisableButton(true);

    const res = await registerUser(registerData);
    const { data: resData, error } = res;

    if (error) {
      toast.dismiss();
      if (error.status == 403) {
        setTimeout(() => window.location.reload(), 1000);
      }
      toast.error(error.data?.message || "Something went wrong");
      setTimeout(() => {
        setDisableButton(false);
      }, 4000);
      return;
    }

    if (resData?.status) {
      setMobile("");
      setEmail("");
      cancelCourse();
      localStorage.removeItem("hemAuth");

      toast.success(
        "Congratulations, your account has been registered successfully"
      );
      setTimeout(() => {
        window.location.href = "/login";
      }, 2000);
    } else {
      toast.error(resData?.message || "Registration failed");
    }

    console.log("register response -->", res);
  };

  const handleValidation = (event) => {
    if (event.key === "e" || event.key === "E") {
      event.preventDefault();
    }
    if (
      event.key === "-" ||
      event.key === "+" ||
      event.key === "!" ||
      event.key === "@" ||
      event.key === "#" ||
      event.key === "$" ||
      event.key === "%" ||
      event.key === "^" ||
      event.key === "&" ||
      event.key === "*" ||
      event.key === "(" ||
      event.key === ")"
    ) {
      event.preventDefault();
    }
  };

  const handlechange = (event) => {
    let { name, value } = event.target;

    // Validation for Referral ID (uppercase alphanumeric, 8 characters, and mixed)
    if (name === "ReferId") {
      setReferalError("");
      // Convert input to uppercase and remove non-alphanumeric characters
      const cleanedValue = value.toUpperCase().replace(/[^A-Z0-9]/g, "");
      setReferId(cleanedValue);

      if (!cleanedValue) {
        setReferalError("");
        return;
      }

      // Initial length and character set validation
      if (cleanedValue && cleanedValue.length !== 8) {
        setReferalError("Referral code must be exactly 8 characters long.");
        return;
      }

      // Check if the string contains at least one letter and at least one number
      // const hasLetter = /[A-Z]/.test(cleanedValue);
      // const hasNumber = /[0-9]/.test(cleanedValue);

      // if (!hasLetter || !hasNumber) {
      //   setReferalError(
      //     "Referral code must be a mix of both letters and numbers."
      //   );
      //   return;
      // }

      // If all checks pass, clear any errors
      setReferalError("");
    }

    // Validation for Verification Code
    if (name === "VerificationCode") {
      // Check if the input contains only digits and no special characters like a dot
      const isStrictlyDigits = /^\d+$/.test(value);

      // Check if the length is exactly 6
      const isSixDigits = value.length === 6;

      // Set the state for the verification code
      setVerificationCode(value);

      // Provide specific error messages based on validation
      if (!isStrictlyDigits) {
        setVerificationError("Verification code must contain only numbers.");
      } else if (!isSixDigits) {
        setVerificationError("Verification code must be exactly 6 digits.");
      } else {
        // If all validation rules pass, clear the error message
        setVerificationError("");
      }
    }
  };

  const handlechangeCheck = (event) => {
    var check1 = event.target.checked;
    var messageCheck1 = "";
    if (!check1) {
      messageCheck1 = "Terms checked required";
    }
    setCheck1(check1);
    setMessageCheck1(messageCheck1);
  };

  const handleClick = () => {
    if (type === "text") {
      setType("password");
    } else {
      setType("text");
    }
  };

  const handleClick1 = () => {
    if (type1 === "text") {
      setType1("password");
    } else {
      setType1("text");
    }
  };

  const handleChange101 = (event) => {
    let { name, value } = event.target;

    if (name == "email") {
      setEmail(value);
      const emailvalidation = EmailValidation(name, value);
      setTextForCode("Get Code");
      setVerificationCode("");
      setEmailError(emailvalidation);
    }

    if (name == "mobile") {
      setMobile(value);
      setTextForCode("Get Code");
      setVerificationCode("");

      const fullNumber = countryCode + value;

      if (!value) {
        setMobileError("This field is required");
      }
      // must contain only digits, no dots, spaces, or symbols
      else if (!/^[0-9]+$/.test(value)) {
        setMobileError("Mobile number must contain digits only");
      }
      // reject same-digit numbers like 9999999999, 8888888888
      else if (/^(\d)\1+$/.test(value)) {
        setMobileError("Invalid mobile number");
      } else if (!isValidPhoneNumber(fullNumber)) {
        setMobileError("Please enter a valid mobile number");
      } else {
        setMobileError(""); // clear error if valid
      }
    }

    // if (name == "verification_code") {
    //   setVerificationError("This field is required");
    // }
    if (name == "password") {
      setPassword(value);
      var passwordError = PasswordValidation(name, value);
      setPasswordIssue(passwordError);

      if (passwordError === "mismatched") {
        setPasswordIssue("");
        setCPasswordIssue("Confirm password does not match");
      }
      if (passwordError === "") {
        setPasswordIssue("");
        setCPasswordIssue("");
      }
    }

    if (name == "cpassword") {
      setCPassword(value);
      var CpasswordError = PasswordValidation(name, value);
      setCPasswordIssue(CpasswordError);

      if (passwordError == "") {
        setCPasswordIssue("");
      }
    }
  };

  const cancelCourse = () => {
    setVerificationCode("");
    setEmail("");
    setPassword("");
    setCPassword("");
    setReferId("");
  };

  const handleMobileSubmit = async (e) => {
    e.preventDefault();

    if (registerVia === "email") {
      if (!email) {
        return setEmailError("This field is required");
      }

      const emailReg =
        /^[a-zA-Z\d\.-]+@([a-zA-Z\.-]+)\.([a-zA-Z]{2,8})([a-zA-Z]{2,8})?$/;

      if (!email.match(emailReg))
        return setEmailError("Please enter a valid email address");

      setEmailError("");
    }

    if (registerVia === "phone") {
      // Validate phone
      if (!mobile) {
        return setMobileError("This field is required");
      }

      const fullNumber = countryCode + mobile;
      if (!isValidPhoneNumber(fullNumber)) {
        return setMobileError("Please enter a valid mobile number");
      }

      setMobileError(""); // Clear errors if valid
    }

    // Build request data
    let data = {
      country_code: countryCode,
      type: registerVia,
      otp: VerificationCode,
      phone: mobile,
      email: registerVia === "email" ? email : "",
    };
    console.log(data, "data");
    // return;

    // OTP field check
    if (!VerificationCode) {
      return setVerificationError("This field is required");
    }
    setVerificationError("");

    // Call mutation
    try {
      setDisableButton(true);
      const res = await signUpVerifyOtp(data);
      const { data: resData, error } = res;

      if (error) {
        toast.dismiss();
        toast.error(error?.data?.message || "Verification failed");
        setTimeout(() => {
          setDisableButton(false);
        }, 4000);
        return;
      }

      if (resData?.status) {
        toast.success(resData.message || "OTP verified successfully");
        setCodeMatchedStatus(true);
        setBtnDisabled(true);
        setDisableButton(false);
        localStorage.setItem("hemAuth", resData?.response?.token);
      } else {
        toast.error(resData?.message || "Verification failed");
      }

      console.log("OTP Verify response:", resData);
    } catch (err) {
      console.error("Unexpected error during OTP verification:", err);
      toast.error("Unexpected error occurred");
    }
  };

  // blocks typing of ., e/E, +/- , comma, numpad decimal
  const blockMobileKeys = (e) => {
    const invalid = [".", "Decimal", "e", "E", "+", "-", ","];
    if (invalid.includes(e.key)) e.preventDefault();
  };

  // blocks pasting non-digits
  const blockMobilePaste = (e) => {
    const text =
      (e.clipboardData || window.clipboardData).getData("text") || "";
    if (/\D/.test(text)) e.preventDefault();
  };

  useEffect(() => {
    console.log("verifyingCode changed:", verifyingCode);
    console.log("code error:", verificationError);
  }, [verifyingCode]);

  const handleRegisterVia = (e) => {
    console.log("Current registerVia:", registerVia);
    if (registerVia === "phone") {
      setRegisterVia("email");
      setMobile("");
      setEmail("");
      setMobileError("");
      setEmailError("");
    } else {
      setRegisterVia("phone");
      setMobile("");
      setEmail("");
      setMobileError("");
      setEmailError("");
    }
  };

  return (
    <DocumentMeta {...meta}>
      <div className="">
        <div className="register-main-outer signup-main-outer position-relative d-flex align-items-center flex-wrap">
          <span className="main-bg fadeInRight animated"></span>
          <div className="register-inner">
            <div className="row m-0 ">
              <div className="col-12 p-0">
                <div className="register-right fadeInLeft animated ">
                  <div className="heading-link-outer">
                    <div className="heading">
                      <h2 className="m-0">Sign Up</h2>
                    </div>
                  </div>

                  <div className="register-form signup-form">
                    <form onSubmit={handleMobileSubmit}>
                      {/* {countryCode == "+91" ? ( */}
                      {/* ) : ( */}
                      {/* <label>Email Address</label> */}
                      {/* )} */}

                      {registerVia === "phone" ? (
                        <>
                          <label>Mobile Number</label>
                          <div className="form-group mb-2 position-relative">
                            <PhoneInput
                              className="country-code position-absolute"
                              countryCodeEditable={false}
                              country={"in"}
                              enableSearch={true}
                              disableCountryCode={true}
                              disableDropdown={
                                codeMatchedStatus || counter == 0 ? false : true
                              }
                              value={countryCode}
                              disabled={true}
                              onChange={handleCountryCode}
                            />
                            {/* {countryCode == "+91" ? ( */}
                            <>
                              <input
                                className="form-control country-input"
                                type="number" // keep number if you insist
                                placeholder="Enter Mobile Number"
                                name="mobile"
                                id="mobile"
                                value={mobile}
                                maxLength={20}
                                onKeyDown={(e) => {
                                  handleValidation(e);
                                  blockMobileKeys(e);
                                }}
                                onPaste={blockMobilePaste}
                                onDrop={(e) => e.preventDefault()} // no drag-n-drop junk
                                onChange={handleChange101}
                                disabled={
                                  codeMatchedStatus
                                    ? codeMatchedStatus
                                    : counter == 0
                                    ? false
                                    : true
                                }
                              />
                            </>
                            {/* ) : ( */}
                            {/* <>
                            <input
                              className="form-control country-input"
                              type="text"
                              placeholder="Enter Email Address"
                              name="email"
                              id="email"
                              maxLength={70}
                              onChange={handleChange101}
                              value={email}
                              disabled={
                                // codeMatchedStatus ||
                                btnDisabled
                                  ? // counter == 0
                                    true
                                  : false
                              }
                            />
                          </> */}
                            {/* )} */}
                            <div style={{ color: "red" }}>
                              {/* {countryCode == "+91" ? mobileError : emailError} */}
                              {mobileError || emailError}
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <label>Email Address</label>
                          <div className="form-group mb-2 position-relative">
                            <>
                              <input
                                className="form-control"
                                type="text"
                                placeholder="Enter Email Address"
                                name="email"
                                id="email"
                                maxLength={70}
                                onChange={handleChange101}
                                value={email}
                                disabled={
                                  // codeMatchedStatus ||
                                  btnDisabled
                                    ? // counter == 0
                                      true
                                    : false
                                }
                              />
                            </>
                            {/* )} */}
                            <div style={{ color: "red" }}>
                              {/* {countryCode == "+91" ? mobileError : emailError} */}
                              {mobileError || emailError}
                            </div>
                          </div>
                        </>
                      )}
                      {/* <div className="text-right">
                        <span
                          onClick={handleRegisterVia}
                          className="login-links"
                        >
                          Via {registerVia === "phone" ? "Email" : "Phone"}
                        </span>
                      </div> */}

                      <div className="form-group">
                        <label>Verification Code</label>
                        <div className="get-outer position-relative">
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter Verification Code"
                            name="VerificationCode"
                            onChange={handlechange}
                            onKeyDown={(e) => {
                              handleValidation(e);
                              blockMobileKeys(e);
                            }}
                            disabled={
                              codeMatchedStatus || buttonDisableVerification
                            }
                            maxLength={6}
                            value={VerificationCode}
                            aria-label="Input group example"
                            aria-describedby="btnGroupAddon"
                          />

                          {!codeMatchedStatus && (
                            <>
                              <div className="get-btn position-absolute">
                                <button
                                  className="btn btn_man"
                                  id="btnGroupAddon"
                                  onClick={getCode}
                                  disabled={codeMatchedStatus || btnDisabled}
                                >
                                  {timerText}
                                  {"  "}
                                  {counter == 0 ? textForCode : counter}
                                </button>
                              </div>
                            </>
                          )}
                        </div>
                        <span style={{ color: "red" }}>
                          {verificationError}
                        </span>
                      </div>
                      {!codeMatchedStatus && (
                        <div className="form-group mx-auto submit-btn">
                          <button
                            className="btn w100 btn_man"
                            disabled={disableButton}
                          >
                            Submit
                          </button>
                        </div>
                      )}
                    </form>
                    {codeMatchedStatus && (
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6 col-12">
                            <div className="form-group">
                              <label>Password</label>
                              <div className="eye_pass">
                                <input
                                  className="form-control"
                                  type={type}
                                  name="password"
                                  id="Password"
                                  placeholder="Enter Password"
                                  maxLength={30}
                                  value={Password}
                                  onChange={handleChange101}
                                />
                                <span
                                  className="password__show eye1"
                                  onClick={handleClick}
                                >
                                  {type === "text" ? (
                                    <i className="las la-eye"></i>
                                  ) : (
                                    <i className="las la-low-vision"></i>
                                  )}
                                </span>
                                {PasswordIssue && (
                                  <div style={{ color: "red" }}>
                                    {PasswordIssue}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-6 col-12">
                            <div className="form-group">
                              <label>Confirm Password</label>
                              <div className="form-group eye_pass">
                                <input
                                  className="form-control"
                                  type={type1}
                                  placeholder="Re-Enter Password"
                                  maxLength={30}
                                  name="cpassword"
                                  id="CPassword"
                                  onChange={handleChange101}
                                  value={CPassword}
                                />
                                <span
                                  className="password__show eye1"
                                  onClick={handleClick1}
                                >
                                  {type1 === "text" ? (
                                    <i className="las la-eye"></i>
                                  ) : (
                                    <i className="las la-low-vision"></i>
                                  )}
                                </span>

                                {CPasswordIssue && (
                                  <div style={{ color: "red" }}>
                                    {CPasswordIssue}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <label>Referral Code(Optional) </label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Enter Referral Code (Optional)"
                            name="ReferId"
                            maxLength={8}
                            onChange={handlechange}
                            value={ReferId}
                            disabled={ref ? true : false}
                          />
                          <span style={{ color: "red" }}>{referalError}</span>
                        </div>
                        <div className="form-group">
                          <div className="custom-control custom-checkbox text-left">
                            <input
                              className="custom-control-input"
                              id="rememberPasswordCheck"
                              type="checkbox"
                              name="check1"
                              onChange={handleChange1}
                              value={check1}
                            />
                            <label
                              className="custom-control-label rember"
                              htmlFor="rememberPasswordCheck"
                            >
                              I agree to the{" "}
                              <a
                                href="/terms-&-conditions-of-crypto-exchange"
                                className="login-links"
                                target="_blank"
                              >
                                <u>Terms & Conditions</u>
                              </a>
                              <span className="regStart">*</span>
                            </label>
                          </div>
                          <span style={{ color: "red" }}>{messageCheck1}</span>
                        </div>

                        <div className="form-group">
                          <button
                            disabled={disableButton}
                            className="btn w100 btn_man"
                          >
                            SIGN UP
                          </button>
                        </div>
                      </form>
                    )}
                    <div class="text-center ">
                      Already have an account?
                      <Link to="/login" className="login-links">
                        {" "}
                        LOGIN
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DocumentMeta>
  );
};

export default RegisterFunction;
